import { isEmpty, isNullish } from 'remeda';

export const findMatchedLevelByPoints = <T extends { levelPoints: number }>(
  availableLevels: T[] | undefined,
  userPoints: number
): T | undefined => {
  if (isNullish(availableLevels) || isEmpty(availableLevels)) return undefined;

  const sorted = [...availableLevels].sort((a, b) => b.levelPoints - a.levelPoints);

  return sorted.find((level) => level.levelPoints <= userPoints);
};
